import {combineReducers} from 'redux';

const UPDATE_LOCALES = 'UPDATE_LOCALES';

function localesReducer(state = {}, action) {
  switch (action.type) {
    case UPDATE_LOCALES:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}

export default localesReducer;
